export default "__VITE_ASSET__V4W_j2l___"